import React from 'react';
import { Link } from 'react-router-dom';
import Formsy from 'formsy-react';
import SimpleInput from '../form/SimpleInput';
import Select from '../form/Select';
import { maskMoney } from '../../masks';
import SVGTrash from '../../svg/Trash';
import { dollarsToCents } from '../../helpers/util';
import { dietPrefIncludesAllergen } from '../../helpers/allergens';

class GroceryList extends React.Component {

  render() {
    const { groceryList = [], isEdit } = this.props;
    return (
      <div className="cms grocery-list">
        {this.renderHeader()}
        <ul>
          {groceryList.map((item, key) =>
            isEdit ? this.renderEdit(item, key) : this.renderView(item, key)
          )}
        </ul>
      </div>
    );
  }

  renderHeader = () => {
    if (this.props.groceryList && this.props.groceryList.length) {
      const amountLabel = this.props.isEdit ? (
        [
          <div
            key={0}
            className="p row__item row__item--pad-right row__item--qty p--bold"
          >
            Qty
          </div>,
          <div
            key={1}
            className="p row__item row__item--pad-right row__item--unit p--bold"
          >
            Unit
          </div>
        ]
      ) : (
        <div className="p row__item row__item--pad-right row__item--amount p--bold">
          Amount
        </div>
      );

      return (
        <div className="row row--space-between">
          <div className="p row__item row__item--pad-right row__item--category p--bold">
            Category
          </div>
          <div className="p row__item row__item--pad-right row__item--name p--bold">
            Name
          </div>
          {amountLabel}
          <div className="p row__item row__item--pad-right row__item--price p--bold">
            Price
          </div>
          <div className="p row__item row__item--pad-right row__item--allergens p--bold">
            Allergens
          </div>
          <div className="p row__item row__item--pad-right row__item--dishes p--bold" >
            For Dishes
          </div>
          <div className="p row__item row__item--pad-right row__item--note p--bold">
            Note
          </div>
          <div className="p row__item row__item--pad-right row__item--cta p--bold" />
        </div>
      );
    }
  };

  renderView(item, key) {
    const {
      name,
      quantity,
      notes,
      category_name,
      format,
      price_cents,
      dishes
    } = this.parseData(item);

    const allergenTags = item.product ? item.product.allergen_tags : [];
    const activeAllergens = this.renderAllergens(allergenTags);

    return (
      <li key={key} className="row row--nowrap row--top-border">
        <div className="row__item row__item--pad-right row__item--category p">
          {category_name}
        </div>
        <div className="row__item row__item--pad-right row__item--name p">
          {name}
        </div>

        <div className="row__item row__item--pad-right row__item--amount p">
          {quantity} {format}
        </div>

        <div className="row__item row__item--pad-right row__item--price p">
          {maskMoney(price_cents)}
        </div>
        <div className="row__item row__item--pad-right row__item--allergens p">
          {activeAllergens}
        </div>
        <div className="row__item row__item--pad-right row__item--dishes p">
          {dishes.map(dish => {
            return <div><Link to={`/admin/dish/${dish.id}`} className="">
              {dish.name}
            </Link></div>
          })}
        </div>
        <div className="row__item row__item--pad-right row__item--notes p">
          {notes}
        </div>
        <div className="p row__item row__item--pad-right row__item--cta" />
      </li>
    );
  }

  renderEdit(item, key) {
    return item.is_custom
      ? this.renderCustomItemEdit(item, key)
      : this.renderItemEdit(item, key);
  }

  renderItemEdit(item, key) {
    const {
      name,
      quantity,
      notes,
      category_name,
      format,
      price_cents
    } = this.parseData(item);

    const activeAllergens = this.renderAllergens(item.product.allergen_tags);

    return (
      <li key={key} className="row row--nowrap row--bordered">
        <div className="row__item row__item--pad-right row__item--category p">
          {category_name}
        </div>
        <div className="row__item row__item--pad-right row__item--name p">
          {name}
        </div>
        <div className="row__item row__item--pad-right row__item--qty p">
          <SimpleInput
            type="number"
            name="quantity"
            value={quantity}
            onChange={e => this.handleChange(key, e)}
          />
        </div>
        <div className="row__item row__item--pad-right row__item--unit p">
          {format}
        </div>
        <div className="row__item row__item--pad-right row__item--price">
          <SimpleInput
            type="text"
            name="custom_price_cents"
            value={price_cents}
            onChange={e => this.handleChange(key, e)}
            mask={maskMoney}
          />
        </div>
        <div className="row__item row__item--pad-right row__item--allergens p">
          {activeAllergens}
        </div>
        <div className="row__item row__item--pad-right row__item--notes">
          <SimpleInput
            type="text"
            name="notes"
            value={notes}
            onChange={e => this.handleChange(key, e)}
          />
        </div>
        <div className="row__item row__item--pad-right row__item--cta">
          <span
            className="btn-icon btn-icon--trash"
            onClick={() => this.deleteItem(key)}
          >
            <SVGTrash />
          </span>
        </div>
      </li>
    );
  }

  renderCustomItemEdit(item, key) {
    const {
      name,
      quantity,
      notes,
      category_name,
      format,
      price_cents
    } = this.parseData(item);

    return (
      <li key={key}>
        <Formsy onSubmit={() => {}} className="row row--nowrap row--bordered">
          <div className="row__item row__item--pad-right row__item--category">
            <Select
              name="custom_category"
              value={category_name}
              options={this.props.availableCategories}
              onChange={e => this.handleSelectChange(key, e)}
            />
          </div>
          <div className="row__item row__item--pad-right row__item--name">
            <SimpleInput
              type="text"
              name="name"
              value={name}
              onChange={e => this.handleChange(key, e)}
            />
          </div>
          <div className="row__item row__item--pad-right row__item--qty p">
            <SimpleInput
              type="number"
              name="quantity"
              value={quantity}
              onChange={e => this.handleChange(key, e)}
            />
          </div>
          <div className="row__item row__item--pad-right row__item--unit p">
            {format}
          </div>
          <div className="row__item row__item--pad-right row__item--price">
            <SimpleInput
              type="text"
              name="custom_price_cents"
              value={price_cents}
              onChange={e => this.handleChange(key, e)}
              mask={maskMoney}
            />
          </div>
          <div className="row__item row__item--pad-right row__item--notes">
            <SimpleInput
              type="text"
              name="notes"
              value={notes}
              onChange={e => this.handleChange(key, e)}
            />
          </div>
          <div className="row__item row__item--pad-right row__item--cta">
            <span
              className="btn-icon btn-icon--trash"
              onClick={() => this.deleteItem(key)}
            >
              <SVGTrash />
            </span>
          </div>
        </Formsy>
      </li>
    );
  }

  renderAllergens(productAllergens) {
    let allergens = productAllergens.map(productAllergen => {
      if (this.isActiveAllergen(productAllergen.tag) === true) {
        return <span className="p--red">{productAllergen.tag}</span>;
      } else {
        return <span>{productAllergen.tag}</span>;
      }
    });

    return allergens;
  }
  isActiveAllergen(allergen) {
    if (!this.props.allergens.length && !this.props.dietaryPreferences)
      return false;

    // eslint-disable-next-line
    let cA = this.props.allergens.filter(clientAllergen => {
      if (clientAllergen.tag === allergen) return true;
    });

    const dietaryPrefs = this.props.dietaryPreferences || [];
    cA = cA.concat(dietaryPrefs.filter(clientDietaryTag => 
      dietPrefIncludesAllergen(clientDietaryTag.tag, allergen)
    ))

    if (cA.length > 0) return true;
    return false;
  }

  parseData = item => {
    const category_name = item.custom_category
      ? item.custom_category // use custom_category when there is one
      : 'product' in item &&
        item.product &&
        'product_category' in item.product &&
        item.product.product_category
      ? item.product.product_category.name // or product_category.name
      : ''; // otherwise empty

    // default to 'x' if there's no product_format
    const format =
      'product' in item &&
      item.product &&
      'product_format' in item.product &&
      item.product.product_format
        ? item.product.product_format.name
        : 'x';

    // use the custom_price_cents over line_amount
    const price_cents = item.custom_price_cents
      ? item.custom_price_cents
      : item.line_amount;
    const { allergen_tags = [] } = item.product || {};

    const allergens = allergen_tags.map(alg => alg.tag).join(', ');

    return {
      name: item.name || '',
      quantity: item.quantity || '',
      notes: item.notes || '',
      category_name,
      format,
      price_cents,
      allergens,
      dishes: item.dishes
    };
  };

  deleteItem = index => {
    const grocery_list_items = [
      ...this.props.groceryList.slice(0, index),
      ...this.props.groceryList.slice(index + 1, this.props.groceryList.length)
    ];
    this.props.updateGroceryList({ grocery_list_items });
  };

  handleChange = (index, e) => {
    const { name, value } = e.target;
    const grocery_list_items = [...this.props.groceryList];
    grocery_list_items[index][name] = [
      'line_amount',
      'custom_price_cents'
    ].includes(name)
      ? dollarsToCents(value)
      : value;
    this.props.updateGroceryList({ grocery_list_items });
  };

  handleSelectChange = (index, option) => {
    const grocery_list_items = [...this.props.groceryList];
    grocery_list_items[index].custom_category = option ? option.value : null;
    this.props.updateGroceryList({ grocery_list_items });
  };

  // componentDidMount(){}
}
export default GroceryList;



// WEBPACK FOOTER //
// ./src/components/groceryList/GroceryList.js